<template>
    <div class="row">
        <div class="col-12">
            <card>
                <div class="card-body">

                  <div class="mb-4">
                      <label class="text-uppercase px-1 mb-0 text-muted">
                          <small>{{$t('part.text.showcategory')}}:</small>
                      </label>
                      <a
                          @click.prevent="onFilterSet"
                          class="btn btn-xs btn-primary px-1 mr-1 mb-1"
                          href
                          data-category-id="all"
                          :disabled="options.params.category == 'all'"
                      >All</a>
                      <slot v-for="category in categories">
                          <a
                              @click.prevent="onFilterSet"
                              class="btn btn-xs btn-primary px-1 mr-1 mb-1"
                              href
                              :data-category-id="category.id"
                              :disabled="options.params.category == category.id"
                          >{{$t('part.categories.' + category.name.toLowerCase())}}</a>
                      </slot>

                      <div class="float-right" v-if="isAdmin">
                        <button class="btn btn-secondary btn-sm" @click="export2Excel">
                          <i class="fas fa-download fa-fw"></i> Download XLS
                        </button>
                      </div>
                  </div>

                    <v-server-table
                      ref="vuetable"
                      url="/dtable/inventory"
                      :columns="dyn_cols"
                      :options="options"
                    >
                        <template slot="beforeFilter">
                            <h2>
                                <i class="fas fa-archive text-primary"></i> {{$t('inventory.title')}}
                            </h2>
                        </template>
                        <template slot="type_name" slot-scope="props">
                            <span
                                class="badge badge-warning text-white"
                                v-if="props.row.type_name == 'In Warranty'"
                            >{{ $t('part.button.' + props.row.type_name.toLowerCase().replace(/\s/g, '')) }}</span>
                            <span
                                class="badge badge-success text-white"
                                v-if="props.row.type_name == 'Early Kit'"
                            >{{ $t('part.button.' + props.row.type_name.toLowerCase().replace(/\s/g, '')) }}</span>
                            <span
                                class="badge badge-primary"
                                v-if="props.row.type_name == 'Stock'"
                            >{{ $t('part.button.' + props.row.type_name.toLowerCase().replace(/\s/g, '')) }}</span>
                            <span
                                class="badge badge-dark"
                                v-if="props.row.type_name == 'Canabalizacao'"
                            >{{ props.row.type_name }}</span>
                        </template>

                        <template slot="beforeTable"  v-if="showIfRoleIs('admin,admin-rede')">
                          <div class="row">
                            <div class="col-md-12 mb-4 px-0 pb-3" v-if="showIfRoleIs('admin,admin-rede')">
                              <label class="text-uppercase text-muted mb-0 mr-2 d-inline-block align-middle">
                                <small>{{$t('part.text.filterbyasf')}}:</small>
                              </label>

                              <div class="d-flex align-items-center">
                                <multiselect
                                  v-model="asf_value"
                                  :options="asfs"
                                  :custom-label="asfLabel"
                                  :placeholder="$t('text.select')"
                                  label="name"
                                  track-by="id"
                                  class="b-form-btn-label-control flex-fill mr-2"
                                  @open="getAsfs"
                                  @input="onAsfFilterChange($event ? $event.id : null)"
                                ></multiselect>

                                <a
                                  @click.prevent="selectAllAsfs"
                                  class="btn btn-primary px-3 rounded"
                                  href
                                >
                                  {{$t('button.allAsfs')}}
                                </a>
                              </div>
                            </div>
                          </div>
                        </template>

                        <template slot="id" slot-scope="props" class="btn-group" role="group" v-if="isAdmin">
                            <router-link
                                class="btn btn-xs btn-primary mr-1"
                                :to="{ name: 'inventory_edit', params: { id: props.row.id } }"
                            >
                                <i class="fas fa-edit fa-fw"></i>
                            </router-link>
                        </template>
                    </v-server-table>
                </div>
            </card>
        </div>
    </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  computed: {
     ...mapState("asfs", {
      asfs: "all"
    }),
    dyn_cols() {
      return ["asf", "part", "sku", "quantity", "reserved", "type_name", "id"];
    },
    isAdmin() {
      return this.$store.getters["auth/getIsAdmin"];
    },
    categories() {
      return this.$store.getters["parts/getCategories"];
    }
  },
  data() {
    return {
      asf_value: "",
      options: {
        dateColumns: [],
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          part: () => this.$t('inventory.name'),
          sku: () => this.$t('inventory.sku'),
          reserved: () => this.$t('inventory.reserved'),
          type_name: () => this.$t('inventory.stock'),
          quantity: () => this.$t('inventory.quantity'),
          id: ""
        },
        texts: {
          count: this.$t('field.count'),
          filter: this.$t('field.filter'),
          filterPlaceholder: this.$t('field.filterplaceholder'),
          limit: this.$t('field.limit'),
        },
        columnsClasses: { id: "text-right" },
        skin: "table table-sm table-hover",
        pagination: {
          edge: true
        },
        params: {
          asf: this.$store.getters["auth/getCurrentAsf"],
          category: "all",
          asf_id: null
        },
        sortIcon: {
          base: "fas fa-sort",
          up: "fas fa-sort-up",
          down: "fas fa-sort-down",
          is: "fas fa-sort"
        }
      }
    };
  },
  methods: {
    asfLabel({ name, vat }) {
      return `${name} — ${vat}`;
    },
    selectAllAsfs() {
      this.asf_value = null;
      this.options.params.asf_id = null;

      this.$nextTick(() => {
        this.$refs.vuetable.refresh();
      });
    },
    showIfRoleIs(role) {
      return this.$store.getters["auth/isInRoles"](role);
    },
    getAsfs() {
      this.$store.dispatch("asfs/getAllAsfs", "name");
    },
    onFilterSet(e) {
      if (e && e.target) {
        const categoryId = e.target.getAttribute("data-category-id");
        this.options.params.category = categoryId || "all";
      }

      this.$nextTick(() => {
        this.$refs.vuetable.refresh();
      });
    },
    onAsfFilterChange(selectedAsf) {
      this.options.params.asf_id = selectedAsf ?? null;
      this.onFilterSet();
    },
    getCurrentDate(){
      var myDate = new Date();
      var month = ('0' + (myDate.getMonth() + 1)).slice(-2);
      var day = ('0' + myDate.getDate()).slice(-2);
      var year = myDate.getFullYear();
      return year + '-' + month + '-' + day;
    },
    export2Excel() {
      import('@/excel/Export2Excel').then(excel => {

        const tHeader = this.dyn_cols.slice(0, -1);//['Serial number', 'Nickname?', 'Full name'];  // Set the title of the first row of Excel table
        const filterVal = this.dyn_cols.slice(0, -1);//['index', 'nickName', 'name'];  // index, nickName and name are properties of objects in tableData
        const list = this.$refs.vuetable.data;  //Save tableData in data to list
        const data = this.formatJson(filterVal, list);

        excel.export_json_to_excel({
          header: tHeader, //Header Required
          data, //Specific data Required
          filename: this.$t('global.repairs') + '_' + this.getCurrentDate(), //Optional
          autoWidth: true, //Optional
          bookType: 'xlsx' //Optional
        })
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    }
  },
  created() {
    this.$store.dispatch("parts/getCategories");
  }
};
</script>
<style>
</style>
